import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import AgentsDropdown from "@Broker/@Modules/agents/components/agents-dropdown.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import InformationalTable from "./informational-table";
import SwitchableInput from "@Shared/components/inputs/switchable-input.vue";
import { mapGetters } from "vuex";
import { getNearAppsAsCSV, getNearFollowupsAsCSV, getNearBirthdaysAsCSV } from "../api/dashboard-api";
import { GET_MORTGAGE_AGENT, GET_BIRTHDAY_AGENT } from "../store/dashboard-getters";
import { CURRENT_ACCOUNT_DETAILS, CURRENT_USER_USERNAME, CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
import { showToast } from "@Shared/utils/constants";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InformationalModal",
  components: {
    GenericModal,
    AgentsDropdown,
    SimpleButton,
    InformationalTable,
    SwitchableInput
  },
  props: {
    infoType: {
      type: String,
      required: true
    },
    infoText: {
      type: String,
      required: true
    },
    numberOfDays: {
      type: [String, Number],
      required: true
    },
    expired: {
      type: Boolean,
      default: false
    },
    completed: {
      type: Boolean,
      default: false
    },
    numberOfClients: {
      type: Number,
      required: true
    },
    loadingItems: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      days: this.numberOfDays,
      selectedAgentUsername: ""
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("DashboardStore", [GET_MORTGAGE_AGENT, GET_BIRTHDAY_AGENT])), mapGetters("AccountStore", [CURRENT_ACCOUNT_DETAILS, CURRENT_USER_USERNAME, CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), {}, {
    centerText() {
      return this.past ? this.$t("dashboard.informationalCards.expiredInThePast") : this.$t("dashboard.informationalCards.inTheNext");
    },
    endText() {
      return this.infoType === "Activity" || !this.isBroker ? this.$tc("global.words.day", 2) : this.$t("global.words.daysFor");
    },
    tableName() {
      let name;
      switch (this.infoType) {
        case "Mortgage":
          name = "Mortgage Table";
          break;
        case "Activity":
          name = "Activity Table";
          break;
        case "Birthday":
          name = "Birthday Table";
      }
      return name;
    },
    noResultText() {
      const texts = {
        Mortgage: this.$t("dashboard.messages.errors.notMortgagesForRenewal", {
          numberOfDays: this.numberOfDays
        }),
        Birthday: this.$t("dashboard.messages.errors.noBirthdaysInTheNext", {
          numberOfDays: this.numberOfDays
        })
      };
      if (this.infoType !== "Activity") {
        return texts[this.infoType];
      } else {
        return this.expired ? this.$t("dashboard.messages.errors.noFollowupsExpired", {
          numberOfDays: this.numberOfDays
        }) : this.$t("dashboard.messages.errors.noFollowupsInTheNext", {
          numberOfDays: this.numberOfDays
        });
      }
    },
    noResultLocation() {
      const locations = {
        Mortgage: "#/applications?addApplication=true",
        Activity: "#/board"
      };
      return locations[this.infoType];
    },
    nextStepText() {
      const texts = {
        Mortgage: this.$t("dashboard.informationalCards.toCreateNewApp"),
        Activity: this.$t("dashboard.informationalCards.goToClientBoard"),
        Birthday: this.$t("dashboard.informationalCards.differentDateRange")
      };
      return texts[this.infoType];
    },
    isBroker() {
      return this.CURRENT_ACCOUNT_DETAILS.accountType === "broker";
    },
    currentAgent() {
      return this.CURRENT_USER_USERNAME;
    },
    isViewOnlyRenewals() {
      return this.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY && this.infoType === "Mortgage";
    }
  }),
  watch: {
    numberOfDays(val) {
      this.loading = false;
      this.days = val;
    },
    days() {
      this.loading = true;
    },
    selectedAgentUsername(agentUsername) {
      this.loadNewInfo({
        agentUsername
      });
    }
  },
  mounted() {
    this.selectedAgentUsername = this.currentAgent;
  },
  methods: {
    toggleValues(toggleKey) {
      const data = {
        days: this.numberOfDays,
        expired: this.expired,
        completed: this.completed,
        [toggleKey]: !this[toggleKey]
      };
      this.$emit("change", data);
      this.logAmplitudeDataChanged(data);
    },
    loadNewInfo(values) {
      const data = _objectSpread({
        days: this.numberOfDays,
        expired: this.expired,
        completed: this.completed
      }, values);
      this.$emit("change", data);
      this.logAmplitudeDataChanged(data);
    },
    async downloadCSV() {
      var _result;
      let result;
      switch (this.infoType) {
        case "Mortgage":
          result = await getNearAppsAsCSV(this.numberOfDays, this.GET_MORTGAGE_AGENT);
          break;
        case "Activity":
          result = await getNearFollowupsAsCSV(this.numberOfDays, this.expired);
          break;
        case "Birthday":
          result = await getNearBirthdaysAsCSV(this.numberOfDays, this.GET_BIRTHDAY_AGENT);
      }
      window.open((_result = result) == null ? void 0 : _result.url, "_blank");
      Amplitude.logEvent("Dashboard - informational card data downloaded as csv", {
        page: "dashboard",
        subpage: this.infoType
      });
    },
    handleNewDays(value) {
      const number = _parseInt(value);
      this.days = number;
      if (number) {
        this.loadNewInfo({
          days: number
        });
      } else {
        showToast("error", "daysMustBeNumber");
      }
    },
    show() {
      this.$refs.informationalModal.show();
    },
    hide() {
      this.$refs.informationalModal.hide();
    },
    handleShow() {
      Amplitude.logEvent("Dashboard - Informational Card Modal Opened", {
        page: "dashboard",
        subpage: this.infoType
      });
    },
    logAmplitudeDataChanged(data) {
      Amplitude.logEvent("Dashboard - informational modal data changed", {
        page: "dashboard",
        subpage: this.infoType,
        data
      });
    }
  }
});